import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/header.css";

const Header: React.FC = () => {
  const location = useLocation();

  return (
    <header className="header">
      <div className="construction-bar">
        <span className="construction-text">Stránka je ve výstavbě - na obsahu i funkcích se stále pracuje  </span>
      </div>
      <nav className="nav">
        <Link
          to="/"
          className={`nav-link ${location.pathname === "/" ? "nav-link-active" : ""}`}
        >
          Domů
        </Link>
        <Link
          to="/o-nas"
          className={`nav-link ${location.pathname === "/o-nas" ? "nav-link-active" : ""}`}
        >
          O nás
        </Link>
        <Link
          to="/informace"
          className={`nav-link ${location.pathname === "/informace" ? "nav-link-active" : ""}`}
        >
          Informace a zajímavosti
        </Link>
        <Link
          to="/kontakt"
          className={`nav-link ${location.pathname === "/kontakt" ? "nav-link-active" : ""}`}
        >
          Kontakt
        </Link>
      </nav>
    </header>
  );
};

export default Header;
